import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsServiceProvider } from '../../../../../../../shared/services/utils/utils-service';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';

@Component({
	selector: 'add-shootproof-gallery-modal',
	template: require('./add-shootProof-gallery.modal.html'),
	styles: [require('./add-shootProof-gallery.modal.scss')]
})
export class AddShootProofGalleryModal {
	@Input('actions') actions;
	@Output('shootProofBrands')
	shootProofBrands: EventEmitter<any> = new EventEmitter<any>();
	disableModals = false;
	modalId = '#addShootProofGalleryModal';
	modalToOpen: string;

	constructor(
		private utilService: UtilsServiceProvider,
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService
	) {}

	showSelectExistingShootProofGalleryModal() {
		this.modalToOpen = '#selectExistingShoopProofGalleryModal';
		this.getBrandsForGalleries();
	}

	showCreateNewShootProofGalleryModal() {
		this.modalToOpen = '#createNewShootProofGalleryModal';
		this.getBrandsForGalleries();
	}

	getBrandsForGalleries() {
		this.disableModals = true;
		this.shootProofDataService
			.getBrandsForGalleriesV1()
			.finally(() => {
				this.disableModals = false;
			})
			.subscribe(
				data => this.successGetBrandsForGalleries(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private successGetBrandsForGalleries(data) {
		this.shootProofBrands.emit(data.data);
		const event = null;
		this.utilService.showNextModal(this.modalId, this.modalToOpen, event);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/integrations/shootProof/modals/add-shootProof-gallery-modal/add-shootProof-gallery.modal.ts